(function () {
  var pcb = window.PCBuilder;
  if (!pcb) return;

  var selections = pcb.selections;
  var container = pcb.container;
  var selectOption = pcb.selectOption;

  var atcRow = document.querySelector('[data-save-build-url]');
  var SAVE_BUILD_URL = atcRow ? (atcRow.dataset.saveBuildUrl || '') : '';
  var GET_BUILD_URL  = atcRow ? (atcRow.dataset.getBuildUrl  || '') : '';
  var EMAIL_BUILD_URL = atcRow ? (atcRow.dataset.emailBuildUrl || '') : '';

  // ---------------------------------------------------------------
  // OPEN MODAL — serialize current selections → POST to AWS Lambda
  // ---------------------------------------------------------------
  function openSaveModal() {
    var overlay = document.querySelector('[data-pcb-save-overlay]');
    var urlInput = document.querySelector('[data-pcb-save-url]');
    if (!overlay || !urlInput) return;

    urlInput.value = '';
    urlInput.placeholder = '';
    urlInput.classList.add('is-loading');
    overlay.style.display = 'flex';
    document.body.style.overflow = 'hidden';

    if (!SAVE_BUILD_URL) {
      urlInput.classList.remove('is-loading');
      urlInput.placeholder = 'Save URL not configured.';
      return;
    }

    var total = 0;
    Object.keys(selections).forEach(function (id) {
      var sel = selections[id];
      if (sel && sel !== 'none') total += (sel.price || 0);
    });

    var config = {
      selections: {},
      total_price: total,
      product_title: ((document.querySelector('.pdp-heading') || {}).textContent || '').trim()
    };

    Object.keys(selections).forEach(function (componentId) {
      var sel = selections[componentId];
      var compEl = container.querySelector('[data-component-id="' + componentId + '"]');
      if (compEl && compEl.dataset.hidden === 'true') return;
      var nameEl = compEl ? compEl.querySelector('.pc-builder__name-collapsed') : null;
      var componentName = nameEl ? nameEl.textContent.trim() : '';
      if (!sel || sel === 'none') {
        config.selections[componentId] = { component_name: componentName, title: 'NONE', variant_id: null, price: 0 };
      } else {
        config.selections[componentId] = {
          component_name: componentName,
          title: sel.title,
          product_id: sel.productId,
          variant_id: sel.variantId,
          price: sel.price
        };
      }
    });

    fetch(SAVE_BUILD_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        product_handle: window.location.pathname.split('/products/')[1] || '',
        config: config
      })
    })
    .then(function (r) { return r.json(); })
    .then(function (data) {
      urlInput.classList.remove('is-loading');
      if (data.short_code) {
        urlInput.value = window.location.origin + '/pages/saved-build?id=' + data.short_code;
      } else {
        urlInput.placeholder = 'Error generating link. Try again.';
      }
    })
    .catch(function () {
      urlInput.classList.remove('is-loading');
      urlInput.placeholder = 'Error generating link. Try again.';
    });
  }

  // ---------------------------------------------------------------
  // CLOSE MODAL
  // ---------------------------------------------------------------
  function closeSaveModal() {
    var overlay = document.querySelector('[data-pcb-save-overlay]');
    if (!overlay) return;
    overlay.style.display = 'none';
    document.body.style.overflow = '';
    var emailInput = document.querySelector('[data-pcb-save-email]');
    if (emailInput) emailInput.value = '';
    var sendBtn = document.querySelector('[data-pcb-save-send]');
    if (sendBtn) { sendBtn.textContent = 'Email'; sendBtn.disabled = false; }
    var copyBtn = document.querySelector('[data-pcb-save-copy]');
    if (copyBtn) copyBtn.textContent = 'Copy';
  }

  // ---------------------------------------------------------------
  // EMAIL BUILD
  // ---------------------------------------------------------------
  function emailBuild() {
    var emailInput = document.querySelector('[data-pcb-save-email]');
    var sendBtn = document.querySelector('[data-pcb-save-send]');
    var urlInput = document.querySelector('[data-pcb-save-url]');
    if (!emailInput || !sendBtn || !urlInput) return;

    var email = emailInput.value.trim();
    if (!email || email.indexOf('@') === -1) return;

    var buildUrl = urlInput.value.trim();
    if (!buildUrl) return;

    var short_code;
    try { short_code = new URL(buildUrl).searchParams.get('id'); } catch (e) { return; }
    if (!short_code) return;

    sendBtn.disabled = true;
    sendBtn.textContent = 'Sending...';

    var rowEl = document.querySelector('[data-save-build-url]');
    var build_summary = {
      product_title: ((document.querySelector('.pdp-heading') || {}).textContent || '').trim(),
      selections: {},
      total_price: (document.querySelector('[data-atc-price]') || {}).textContent || '',
      case_image: null,
      site_name: rowEl ? (rowEl.dataset.emailSiteName || 'META PCs') : 'META PCs',
      logo_url: rowEl ? (rowEl.dataset.emailLogo || '') : ''
    };

    var caseComp = container.querySelector('[data-is-case="true"]');
    if (caseComp) {
      var caseSel = selections[caseComp.dataset.componentId];
      if (caseSel && caseSel !== 'none') {
        var caseTile = caseComp.querySelector('[data-product-id="' + caseSel.productId + '"]');
        var caseImg = caseTile ? caseTile.querySelector('.pc-builder__option-image img') : null;
        if (caseImg) build_summary.case_image = caseImg.src;
      }
    }

    // Add config selector first (excluded from selections object, read from DOM)
    var configSelectorEl = container.querySelector('[data-is-config-selector="true"]');
    if (configSelectorEl) {
      var csNameEl = configSelectorEl.querySelector('.pc-builder__name-collapsed');
      var csValueEl = configSelectorEl.querySelector('.pc-builder__component-selection');
      var csName = csNameEl ? csNameEl.textContent.trim() : 'Configuration';
      var csTitle = csValueEl ? csValueEl.textContent.trim() : '';
      if (csTitle) {
        build_summary.selections['_config'] = { component_name: csName, title: csTitle };
      }
    }

    Object.keys(selections).forEach(function (componentId) {
      var sel = selections[componentId];
      var compEl = container.querySelector('[data-component-id="' + componentId + '"]');
      if (compEl && compEl.dataset.hidden === 'true') return;
      var nameEl = compEl ? compEl.querySelector('.pc-builder__name-collapsed') : null;
      var componentName = nameEl ? nameEl.textContent.trim() : '';
      // Fallback for dynamically-cloned slots (expandRepeatableSlots) whose DOM element
      // may not be found via data-component-id — look up the name from PCB_SLOTS.
      if (!componentName && window.PCB_SLOTS) {
        var slotInfo = window.PCB_SLOTS.find(function(s) { return s.handle === componentId; });
        if (slotInfo) componentName = (slotInfo.title || componentId).replace(/^\s*configurator\s*:\s*/i, '').trim();
      }
      build_summary.selections[componentId] = {
        component_name: componentName,
        title: (!sel || sel === 'none') ? 'NONE' : sel.title
      };
    });

    fetch(EMAIL_BUILD_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email: email, short_code: short_code, build_summary: build_summary })
    })
    .then(function (r) {
      if (!r.ok) throw new Error('Email failed');
      sendBtn.textContent = 'Sent!';
      setTimeout(function () { sendBtn.textContent = 'Email'; sendBtn.disabled = false; }, 2500);
    })
    .catch(function () {
      sendBtn.textContent = 'Error';
      setTimeout(function () { sendBtn.textContent = 'Email'; sendBtn.disabled = false; }, 2500);
    });
  }

  // ---------------------------------------------------------------
  // RESTORE FROM ?build=shortCode
  // ---------------------------------------------------------------
  // Look up a product's spec.platform from its variant_id by scanning window.PCB_SLOTS.
  // Used so we can set the platform pill correctly BEFORE running the restore loop —
  // otherwise the platform-filter would disable the saved CPU mid-restore and auto-move
  // back to the default.
  function findPlatformByVariantId(variantId) {
    if (!variantId || !window.PCB_SLOTS) return null;
    var vid = String(variantId);
    for (var i = 0; i < window.PCB_SLOTS.length; i++) {
      var slot = window.PCB_SLOTS[i];
      if (!/cpu/i.test(slot.handle)) continue;
      var products = slot.products || [];
      for (var p = 0; p < products.length; p++) {
        var variants = products[p].variants || [];
        for (var v = 0; v < variants.length; v++) {
          if (String(variants[v].id) === vid) {
            var pf = products[p].spec && products[p].spec.platform;
            return pf ? String(pf).toLowerCase() : null;
          }
        }
      }
    }
    return null;
  }

  function finishRestore() {
    if (pcb.setBatchRestore) pcb.setBatchRestore(false);
    if (pcb.setSuppressPrices) pcb.setSuppressPrices(false);
    // One render pass for everything: rules, spec counts, prices, dispatch.
    // suppressAutoMove stays true through this flush so the saved selections are
    // never swapped out; we re-enable it immediately after.
    if (pcb.flushBatch) pcb.flushBatch();
    else if (pcb.recalcPrices) pcb.recalcPrices();
    if (pcb.setSuppressAutoMove) pcb.setSuppressAutoMove(false);
    if (pcb.removeRestoreOverlay) pcb.removeRestoreOverlay();
    var url = new URL(window.location.href);
    url.searchParams.delete('build');
    window.history.replaceState({}, '', url.toString());
  }

  function checkSavedBuild() {
    var buildCode = new URLSearchParams(window.location.search).get('build');
    if (!buildCode || !GET_BUILD_URL) {
      // No saved build to restore — clear the overlay set by the inline init.
      if (buildCode && pcb.removeRestoreOverlay) pcb.removeRestoreOverlay();
      return;
    }

    fetch(GET_BUILD_URL + '?code=' + encodeURIComponent(buildCode))
      .then(function (r) {
        if (!r.ok) throw new Error('Not found');
        return r.json();
      })
      .then(function (data) {
        if (!data.config || !data.config.selections) { finishRestore(); return; }
        var selMap = data.config.selections;

        // Find the saved CPU and set the platform pill FIRST so the platform filter is
        // aligned with what we're about to restore (no mid-restore auto-moves to Intel).
        var savedCpuVariantId = null;
        Object.keys(selMap).forEach(function (k) {
          if (savedCpuVariantId) return;
          if (/cpu/i.test(k)) {
            var s = selMap[k];
            if (s && s.variant_id) savedCpuVariantId = s.variant_id;
          }
        });
        var savedPlatform = findPlatformByVariantId(savedCpuVariantId);
        if (savedPlatform && pcb.setPlatform) pcb.setPlatform(savedPlatform);

        // Chassis/motherboard first so applySpecCounts reveals multiplied slots
        // (sata-ssd--2, fan--3, etc.) before we try to restore selections into them.
        var priority = ['chassis', 'case', 'motherboard', 'mobo'];
        var orderedKeys = Object.keys(selMap).sort(function (a, b) {
          var aScore = priority.some(function (k) { return a.toLowerCase().indexOf(k) !== -1; }) ? 0 : 1;
          var bScore = priority.some(function (k) { return b.toLowerCase().indexOf(k) !== -1; }) ? 0 : 1;
          return aScore - bScore;
        });

        // Batch mode: selectOption only updates DOM classes/state, skipping the heavy
        // eval cycle. We'll flush once at the end via finishRestore -> flushBatch.
        if (pcb.setBatchRestore) pcb.setBatchRestore(true);
        if (pcb.setSuppressAutoMove) pcb.setSuppressAutoMove(true);
        if (pcb.setSuppressPrices) pcb.setSuppressPrices(true);

        // applySpecCounts needs chassis/MB recorded so it can reveal repeatable extra slots
        // (sata-ssd--2, fan--3 etc.) before the remaining iterations try to select into them.
        var revealedExtras = false;
        for (var i = 0; i < orderedKeys.length; i++) {
          var componentId = orderedKeys[i];
          var sel = selMap[componentId];
          var compEl = container.querySelector('[data-component-id="' + componentId + '"]');
          if (compEl && sel && sel.variant_id) {
            // Find tile by product_id (stable) — avoids missing non-default variants
            var tile = (sel.product_id && compEl.querySelector('[data-product-id="' + sel.product_id + '"]'))
              || compEl.querySelector('[data-variant-id="' + sel.variant_id + '"]');
            if (tile) {
              // Stamp the saved variant onto the tile so selectOption records the right variantId.
              // Price comes from the CURRENT catalog, not the saved record — prices can change
              // between when a build was saved and when it's restored.
              tile.dataset.variantId = String(sel.variant_id);
              var livePrice = pcb.getLiveVariantPrice ? pcb.getLiveVariantPrice(tile.dataset.productHandle, sel.variant_id) : null;
              if (livePrice !== null) tile.dataset.price = livePrice;
              else if (sel.price !== undefined) tile.dataset.price = sel.price;
              // Activate the correct variant thumb if a thumb strip exists
              var thumbsEl = tile.querySelector('.pcb-variant-thumbs');
              if (thumbsEl) {
                thumbsEl.querySelectorAll('[data-variant-id]').forEach(function(t) {
                  t.classList.toggle('pcb-variant-thumb--active', t.dataset.variantId === String(sel.variant_id));
                });
              }
              selectOption(compEl, tile);
            }
          }
          // After chassis + MB are placed, reveal expanded repeatable slots so the
          // remaining iterations can find their target [data-component-id="sata-ssd--2"] etc.
          if (!revealedExtras && priority.some(function (k) { return componentId.toLowerCase().indexOf(k) !== -1; })) {
            // Check if next key is non-priority (chassis/MB phase done)
            if (i + 1 >= orderedKeys.length || !priority.some(function (k) { return orderedKeys[i + 1].toLowerCase().indexOf(k) !== -1; })) {
              // Only run applySpecCounts here (to reveal fan--2, sata-ssd--3, etc.) —
              // evaluateRules fires once at the end in finishRestore with all
              // selections in place, so rules never see a partial state.
              if (pcb.applySpecCounts) pcb.applySpecCounts();
              revealedExtras = true;
            }
          }
        }

        finishRestore();
      })
      .catch(function (e) {
        console.warn('PCBuilder: failed to restore saved build', e);
        finishRestore();
      });
  }

  // ---------------------------------------------------------------
  // EVENT LISTENERS
  // ---------------------------------------------------------------
  var saveBtn = document.querySelector('[data-pcb-save]');
  if (saveBtn) saveBtn.addEventListener('click', openSaveModal);

  var closeBtn = document.querySelector('[data-pcb-save-close]');
  if (closeBtn) closeBtn.addEventListener('click', closeSaveModal);

  var overlay = document.querySelector('[data-pcb-save-overlay]');
  if (overlay) overlay.addEventListener('click', function (e) {
    if (e.target === overlay) closeSaveModal();
  });

  var copyBtn = document.querySelector('[data-pcb-save-copy]');
  if (copyBtn) copyBtn.addEventListener('click', function () {
    var urlInput = document.querySelector('[data-pcb-save-url]');
    if (!urlInput || !urlInput.value) return;
    navigator.clipboard.writeText(urlInput.value).then(function () {
      copyBtn.textContent = 'Copied!';
      setTimeout(function () { copyBtn.textContent = 'Copy'; }, 2000);
    }).catch(function () {
      urlInput.select();
      document.execCommand('copy');
      copyBtn.textContent = 'Copied!';
      setTimeout(function () { copyBtn.textContent = 'Copy'; }, 2000);
    });
  });

  var sendBtn = document.querySelector('[data-pcb-save-send]');
  if (sendBtn) sendBtn.addEventListener('click', emailBuild);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeSaveModal();
  });

  checkSavedBuild();
})();
